export default class GamifiedVideoSelect {
    #selectElement
    #titleElement
    #descriptionElement
    #imageElement

    constructor(element) {
        this.#selectElement = element
        this.#titleElement = document.querySelector(element.dataset.gpTitleTarget)
        this.#descriptionElement = document.querySelector(element.dataset.gpDescriptionTarget)
        this.#imageElement = document.querySelector(element.dataset.gpImageTarget)

        this.#bindEvents()
        this.#handleChange()
    }

    static initAll(selector) {
        Array.from(
            document.querySelectorAll(selector),
            (element) => new GamifiedVideoSelect(element)
        )
    }

    #bindEvents() {
        this.#selectElement.addEventListener('change', () => {
            this.#handleChange()
        })
    }

    #handleChange() {
        let selectedOption = this.#selectElement.options[this.#selectElement.selectedIndex]

        this.#titleElement.innerText = selectedOption.dataset.gpTitle ?? 'Titel video'
        this.#descriptionElement.innerText =
            selectedOption.dataset.gpDescription ?? 'Omschrijving video'
        this.#imageElement.innerHTML = selectedOption.dataset.gpImage
            ? '<img src="' +
              selectedOption.dataset.gpImage +
              '" alt="' +
              (selectedOption.dataset.gpTitle ?? '') +
              '" class="card-img gp-video-image">'
            : ''
    }
}
